import { defineMessages } from 'react-intl';

export default defineMessages({
  AppealOnMeritsInfoTitle: {
    id: 'legal_proceeding_page.appeal_on_merits_info_title',
  },
  condamnationFieldTitle: {
    id: 'legal_proceeding_page.judgement_on_merits.condamnation_field',
  },
  suedPartyTitle: {
    id: 'legal_proceeding_page.judgement_on_merits_sued_party_title',
  },
  JudgementAppealCivilTitle: {
    id: 'legal_proceeding_page.judgement_appeal.civil_judgement_title',
  },
  judgementCivil: {
    id:
      'legal_proceeding_page.judgement_add.judgement_add_pronouncing.recap.title.judgementCivil',
  },
  revenueFieldTitle: {
    id: 'legal_proceeding_page.judgement_on_merits.revenue_field',
  },
  judiciaryAmount: {
    id: 'legal_proceeding_page.judgement_on_merits.judiciary_amount_field',
  },
  calculatedCompensationFieldTitle: {
    id:
      'legal_proceeding_page.judgement_on_merits.calculated_compensation_field',
  },
  judgementCivilRecap: {
    id:
      'legal_proceeding_page.judgement_add.judgement_add_pronouncing.recap.title.judgementCivil.recap',
  },
  AppealAddTitle: {
    id:
      'legal_proceeding_page.judgement_add.judgement_add_pronouncing.recap.title.AppealAdd',
  },
  addButton: {
    id:
      'legal_proceeding_page.judgement_add.judgement_add_pronouncing.recap.title.AppealAdd.addButton',
  },
  appealOnMeritsDate: {
    id: 'legal_proceeding_page.judgement_add.appeal_on_merits.date',
  },
  judgementOnMeritsNumberFieldTitle: {
    id: 'legal_proceeding_page.judgement_on_merits.number_field',
  },
  courtManagerValidationDialogSuccessMessage: {
    id:
      'court_manager_legal_proceedings_page.judgement_add.confirmation_dialog.success_message',
  },
  cancelButton: {
    id:
      'legal_proceeding_page.judgement_add.judgement_add_pronouncing.recap.title.judgementAdd.cancelButton',
  },
  deceasedVictims: {
    id: 'legal_proceeding_page.judgement_on_merits_deceased_victims_title',
  },
  saveButton: {
    id:
      'legal_proceeding_page.judgement_add.judgement_add_pronouncing.recap.title.judgementAdd.saveButton',
  },
  goBackButton: {
    id:
      'legal_proceeding_page.judgement_add.judgement_add_pronouncing.recap.title.judgementAdd.goBackButton',
  },
  validateButton: {
    id:
      'legal_proceeding_page.judgement_add.judgement_add_pronouncing.recap.title.judgementAdd.validateButton',
  },
  correctionalJudgementTitle: {
    id: 'legal_proceeding_page.correctional_judgement_title',
  },
  JudgementAppealCivilDamageAmount: {
    id: 'legal_proceeding_page.judgement_on_merits.damage_amount_field',
  },
  JudgementAppealCompensationField: {
    id: 'legal_proceeding_page.judgement_appeal.appeal_civil.compensation',
  },
  JudgementAppealCalculatedCompensation: {
    id:
      'legal_proceeding_page.judgement_appeal.appeal_civil.calculated_compensation',
  },
  JudgementAppealRevenuField: {
    id: 'legal_proceeding_page.judgement_on_merits.revenue_field',
  },
  JudgementAppealCalculatedRevenu: {
    id: 'legal_proceeding_page.judgement_on_merits.calculated_revenue_field',
  },
  judgementOnMeritsAdditionalInfo: {
    id: 'legal_proceeding_page.judgement_on_merits_additional_info_title',
  },

  successDialogTitle: {
    id:
      'legal_proceeding_page.judgement_add.judgement_add.success_dialog.title',
  },
  successDialogPrimaryButtonTitle: {
    id:
      'legal_proceeding_page.judgement_add.judgement_add.success_dialog.primary_button_title',
  },
  successDialogSecondaryButtonTitle: {
    id:
      'legal_proceeding_page.judgement_add.judgement_add.success_dialog.secondary_button_title',
  },
  successDialogPrimaryButtonTitleJdd: {
    id: 'success_dialog.fee_note',
  },
  doNotGenerateFeeNote: {
    id: 'success_dialog.do_not_generate_fee_note',
  },
  contestationButton: {
    id: 'court_manager_legal_proceedings_page.expert_report.decision.contest',
  },
  contestationDrawerTitle: {
    id:
      'court_manager_legal_proceedings_page.judgement_on_merits.contestation_drawer_title',
  },
  judgementOnMeritsContestationType: {
    id:
      'court_manager_legal_proceedings_page.judgement_on_merits.contestation_drawer_type',
  },
  judgementOnMeritsContestationWithdrawalReason: {
    id:
      'court_manager_legal_proceedings_page.judgement_on_merits.contestation_drawer_withdrawal_reason',
  },
  judgementOnMeritsContestationOwner: {
    id:
      'court_manager_legal_proceedings_page.judgement_on_merits.contestation_drawer_owner',
  },
  judgementOnMeritsContestationAgainst: {
    id:
      'court_manager_legal_proceedings_page.judgement_on_merits.contestation_drawer_against',
  },
  judgementOnMeritsContestationCommentary: {
    id:
      'court_manager_legal_proceedings_page.judgement_on_merits.contestation_drawer_commentary',
  },
  judgementOnMeritsContestationDifficultyExecution: {
    id:
      'court_manager_legal_proceedings_page.judgement_on_merits.contestation_difficulty_execution',
  },
  judgementOnMeritsContestationDefenseExecution: {
    id:
      'court_manager_legal_proceedings_page.judgement_on_merits.contestation_defense_execution',
  },
  judgementOnMeritsContestationSuccessCallback: {
    id:
      'court_manager_legal_proceedings_page.judgement_on_merits.contestation_drawer_success',
  },
  validateRequiredField: {
    id: 'validate.required_field',
  },
  managerDecisionTitle: {
    id: 'manager.decision.title',
  },
  contestationDrawer: {
    id:
      'court_manager_legal_proceedings_page.judgement_on_merits.contestation_drawer',
  },
  jomToastSuccess: {
    id: 'appeal_on_merits.success',
  },
  reject: {
    id:
      'legal_proceeding_page.judgement_add.judgement_add_pronouncing.recap.title.judgementOnMerits.reject',
  },
  rejectedTitle: {
    id: 'legal_proceeding_page_info_rejected_title',
  },
  responsibiltySharePercentage: {
    id: 'preopening_page.claim_circumstances.responsibilty_percentage',
  },
  injuredVictim: {
    id: 'legal_proceeding_page.judgement_on_merits_injured_victims_title',
  },
  sharedResponsability: {
    id: 'legal_proceeding_page.judgement_on_merits_shared_responsibility_title',
  },
  judgementOnMeritsContestationBeneficiaries: {
    id:
      'court_manager_legal_proceedings_page.judgement_on_merits.contestation_drawer_beneficiaries',
  },
  lawyerFirmReferenceUpdateMessage: {
    id: 'legal_proceeding_page.check_firm_reference_info',
  },
  lawyerFirmReferenceEditMessage: {
    id: 'legal_proceeding_page.check_update_firm_reference_info',
  },
  lawyerFirmReferenceDialogLabel: {
    id: 'legal_proceeding_page.update_firm_reference_dialog_label',
  },
  creatorTitle: {
    id: 'legal_proceeding_page.update_firm_reference_lawyer_name',
  },
  reasonField: {
    id: 'legal_proceeding_page.judgement_on_merits.reason',
  },
  editButton: {
    id:
      'legal_proceeding_page.judgement_add.judgement_add_pronouncing.recap.title.judgementAdd.updateButton',
  },
  generateFeeNote: {
    id:
      'legal_proceeding_page.judgement_add.judgement_add_pronouncing.recap.title.judgementAdd.generateFeeNote',
  },
  judgementDateError: {
    id: 'legal_proceeding_page.judgement_add.judgement_on_merits.date_error',
  },
  updateJom: { id: 'legal_proceeding_page.judgement_on_merits.update' },
  updatedStepSuccessMessage: {
    id:
      'court_manager_legal_proceedings_page.step.modification_dialog.success_message',
  },
  courtFileNumberError: {
    id: 'legal_proceeding_page.number_field.error',
  },
  expertReportNotValidated: {
    id: 'legal_proceeding_page.judgement_on_merits_expert_report_warning',
  },
  expertReportNotExist: {
    id:
      'legal_proceeding_page.judgement_on_merits_expert_report_not_exist_warning',
  },
  invalidDate: {
    id: 'preopening_page.invalid_date',
  },
  invoiceNumberField: {
    id: 'invoice.dialog_info.field_invoice_number',
  },
  invoiceDateField: {
    id: 'invoice.dialog_info.field_invoice_date',
  },
  invoiceReceptionDateField: {
    id: 'invoice.dialog_info.field_invoice_reception_date',
  },
  userNotValidWarning: {
    id: 'restricted_user_warning.title',
  },
  expertReportWithoutDecision: {
    id:
      'court_manager_legal_proceedings_page.judgement_on_merits.expertise_report_alert',
  },
  archiveJudgementTitle: {
    id:
      'court_manager_legal_proceedings_page.archive_judgement_on_the_merits.title',
  },
  archiveSuccessToast: {
    id:
      'court_manager_legal_proceedings_page.archive_judgement.success_message',
  },
  archiveJudgementSubTitle: {
    id:
      'court_manager_legal_proceedings_page.archive_judgement.content_message',
  },
  confirm: {
    id: 'court_manager_legal_proceedings_page.expert_report.decision.confirm',
  },
  cancel: {
    id:
      'court_manager_legal_proceedings_page.judgement_add.refusal_popin.cancel',
  },
  archiveReasonFieldError: {
    id:
      'court_manager_legal_proceedings_page.archive_judgement_on_the_merits.error_field',
  },
  intervenantName: {
    id: 'invoice.dialog_info.intervenant.name',
  },
});
